import React, {FC} from 'react';

import {Trans} from '../../../../libs/shared/helpers/src/internationalization/react';
import {Handler} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {DropdownProps} from '../../../../libs/shared/ui/src/components/dropdowns/dropdown';
import {DropdownItem} from '../../../../libs/shared/ui/src/components/dropdowns/dropdownItem';
import {DropdownItemContent} from '../../../../libs/shared/ui/src/components/dropdowns/dropdownItemContent';
import {SimpleDropdown} from '../../../../libs/shared/ui/src/components/dropdowns/simpleDropdown';

/*
 * Props.
 */

interface SchedulingLinksListItemDropdownProps extends DropdownProps {
  onDeleteClick: Handler;
  onEditClick: Handler;
}

/*
 * Component.
 */

export const SchedulingLinksListItemDropdown: FC<SchedulingLinksListItemDropdownProps> = (props) => {
  const {onDeleteClick, onEditClick, ...dropdownProps} = props;

  // TODO: implement onSelect callbacks
  return (
    <SimpleDropdown {...dropdownProps}>
      <DropdownItem onSelect={onEditClick}>
        <DropdownItemContent>
          <Trans id="schedulinglink-list-dropdown-edit">Edit</Trans>
        </DropdownItemContent>
      </DropdownItem>
      <DropdownItem onSelect={onDeleteClick}>
        <DropdownItemContent>
          <Trans id="schedulinglink-list-dropdown-delete">Delete</Trans>
        </DropdownItemContent>
      </DropdownItem>
    </SimpleDropdown>
  );
};
